/* eslint-disable prettier/prettier */
/* eslint-disable */

import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const useScrollFadeIn = () => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      gsap.fromTo(
        ref.current,
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: ref.current,
            start: "top 85%", // Når 85% av seksjonen er synlig
            toggleActions: "play none none reverse",
          },
        }
      );
    }
  }, []);

  return ref;
};

export default useScrollFadeIn;
